import { Box } from 'shared/mui/Box';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';

type Props = {
  title: string;
};

export const OrderManualCreateSection: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  children,
}) => (
  <Box mb={3}>
    <TypographyBold component="h3" fontSize="16px" mb={3} mt={3} text={title} />
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        gap: 3,
        alignItems: 'start',
      }}
    >
      {children}
    </Box>
  </Box>
);
